export const ageDays = (birthtime) => {
  const now = Math.floor(Date.now() / 1000)
  const deltatime = now - Number(birthtime)
  return Math.floor(deltatime / 86400)
}